const country = [{
    "en": "quanbu",
    "py": "A",
    "cn": "全部"
}, {
    "en": "Angola",
    "py": "A",
    "cn": "安哥拉"
}, {
    "en": "Afghanistan",
    "py": "A",
    "cn": "阿富汗"
}, {
    "en": "Albania",
    "py": "A",
    "cn": "阿尔巴尼亚"
}, {
    "en": "Algeria",
    "py": "A",
    "cn": "阿尔及利亚"
}, {
    "en": "Andorra",
    "py": "A",
    "cn": "安道尔共和国"
}, {
    "en": "Anguilla",
    "py": "A",
    "cn": "安圭拉岛"
}, {
    "en": "Antigua and Barbuda",
    "py": "A",
    "cn": "安提瓜和巴布达"
}, {
    "en": "Argentina",
    "py": "A",
    "cn": "阿根廷"
}, {
    "en": "Armenia",
    "py": "Y",
    "cn": "亚美尼亚"
}, {
    "en": "Ascension",
    "py": "A",
    "cn": "阿森松"
}, {
    "en": "Australia",
    "py": "A",
    "cn": "澳大利亚"
}, {
    "en": "Austria",
    "py": "A",
    "cn": "奥地利"
}, {
    "en": "Azerbaijan",
    "py": "A",
    "cn": "阿塞拜疆"
}, {
    "en": "Bahamas",
    "py": "B",
    "cn": "巴哈马"
}, {
    "en": "Bahrain",
    "py": "B",
    "cn": "巴林"
}, {
    "en": "Bangladesh",
    "py": "M",
    "cn": "孟加拉国"
}, {
    "en": "Barbados",
    "py": "B",
    "cn": "巴巴多斯"
}, {
    "en": "Belarus",
    "py": "B",
    "cn": "白俄罗斯"
}, {
    "en": "Belgium",
    "py": "B",
    "cn": "比利时"
}, {
    "en": "Belize",
    "py": "B",
    "cn": "伯利兹"
}, {
    "en": "Benin",
    "py": "B",
    "cn": "贝宁"
}, {
    "en": "Bermuda Is",
    "py": "B",
    "cn": "百慕大群岛"
}, {
    "en": "Bolivia",
    "py": "B",
    "cn": "玻利维亚"
}, {
    "en": "Botswana",
    "py": "B",
    "cn": "博茨瓦纳"
}, {
    "en": "Brazil",
    "py": "B",
    "cn": "巴西"
}, {
    "en": "Brunei",
    "py": "W",
    "cn": "文莱"
}, {
    "en": "Bulgaria",
    "py": "B",
    "cn": "保加利亚"
}, {
    "en": "Burkina Faso",
    "py": "B",
    "cn": "布基纳法索"
}, {
    "en": "Burma",
    "py": "M",
    "cn": "缅甸"
}, {
    "en": "Burundi",
    "py": "B",
    "cn": "布隆迪"
}, {
    "en": "Cameroon",
    "py": "K",
    "cn": "喀麦隆"
}, {
    "en": "Canada",
    "py": "J",
    "cn": "加拿大"
}, {
    "en": "Cayman Is",
    "py": "K",
    "cn": "开曼群岛"
}, {
    "en": "Central African Republic",
    "py": "Z",
    "cn": "中非共和国"
}, {
    "en": "Chad",
    "py": "Z",
    "cn": "乍得"
}, {
    "en": "Chile",
    "py": "Z",
    "cn": "智利"
}, {
    "en": "China",
    "py": "Z",
    "cn": "中国"
}, {
    "en": "Colombia",
    "py": "G",
    "cn": "哥伦比亚"
}, {
    "en": "Congo",
    "py": "G",
    "cn": "刚果"
}, {
    "en": "Cook Is",
    "py": "K",
    "cn": "库克群岛"
}, {
    "en": "Costa Rica",
    "py": "G",
    "cn": "哥斯达黎加"
}, {
    "en": "Cuba",
    "py": "G",
    "cn": "古巴"
}, {
    "en": "Cyprus",
    "py": "S",
    "cn": "塞浦路斯"
}, {
    "en": "Czech Republic",
    "py": "J",
    "cn": "捷克"
}, {
    "en": "Denmark",
    "py": "D",
    "cn": "丹麦"
}, {
    "en": "Djibouti",
    "py": "J",
    "cn": "吉布提"
}, {
    "en": "Dominica Rep",
    "py": "D",
    "cn": "多米尼加共和国"
}, {
    "en": "Ecuador",
    "py": "E",
    "cn": "厄瓜多尔"
}, {
    "en": "Egypt",
    "py": "A",
    "cn": "埃及"
}, {
    "en": "EI Salvador",
    "py": "S",
    "cn": "萨尔瓦多"
}, {
    "en": "Estonia",
    "py": "A",
    "cn": "爱沙尼亚"
}, {
    "en": "Ethiopia",
    "py": "A",
    "cn": "埃塞俄比亚"
}, {
    "en": "Fiji",
    "py": "Z",
    "cn": "斐济"
}, {
    "en": "Finland",
    "py": "F",
    "cn": "芬兰"
}, {
    "en": "France",
    "py": "F",
    "cn": "法国"
}, {
    "en": "French Guiana",
    "py": "F",
    "cn": "法属圭亚那"
}, {
    "en": "French Polynesia",
    "py": "F",
    "cn": "法属玻利尼西亚"
}, {
    "en": "Gabon",
    "py": "J",
    "cn": "加蓬"
}, {
    "en": "Gambia",
    "py": "G",
    "cn": "冈比亚"
}, {
    "en": "Georgia",
    "py": "G",
    "cn": "格鲁吉亚"
}, {
    "en": "Germany",
    "py": "D",
    "cn": "德国"
}, {
    "en": "Ghana",
    "py": "J",
    "cn": "加纳"
}, {
    "en": "Gibraltar",
    "py": "Z",
    "cn": "直布罗陀"
}, {
    "en": "Greece",
    "py": "X",
    "cn": "希腊"
}, {
    "en": "Grenada",
    "py": "G",
    "cn": "格林纳达"
}, {
    "en": "Guam",
    "py": "G",
    "cn": "关岛"
}, {
    "en": "Guatemala",
    "py": "W",
    "cn": "危地马拉"
}, {
    "en": "Guinea",
    "py": "J",
    "cn": "几内亚"
}, {
    "en": "Guyana",
    "py": "G",
    "cn": "圭亚那"
}, {
    "en": "Haiti",
    "py": "H",
    "cn": "海地"
}, {
    "en": "Honduras",
    "py": "H",
    "cn": "洪都拉斯"
}, {
    "en": "Hongkong",
    "py": "X",
    "cn": "香港"
}, {
    "en": "Hungary",
    "py": "X",
    "cn": "匈牙利"
}, {
    "en": "Iceland",
    "py": "B",
    "cn": "冰岛"
}, {
    "en": "India",
    "py": "Y",
    "cn": "印度"
}, {
    "en": "Indonesia",
    "py": "Y",
    "cn": "印度尼西亚"
}, {
    "en": "Iran",
    "py": "Y",
    "cn": "伊朗"
}, {
    "en": "Iraq",
    "py": "Y",
    "cn": "伊拉克"
}, {
    "en": "Ireland",
    "py": "A",
    "cn": "爱尔兰"
}, {
    "en": "Israel",
    "py": "Y",
    "cn": "以色列"
}, {
    "en": "Italy",
    "py": "Y",
    "cn": "意大利"
}, {
    "en": "Ivory Coast",
    "py": "K",
    "cn": "科特迪瓦"
}, {
    "en": "Jamaica",
    "py": "Y",
    "cn": "牙买加"
}, {
    "en": "Japan",
    "py": "R",
    "cn": "日本"
}, {
    "en": "Jordan",
    "py": "Y",
    "cn": "约旦"
}, {
    "en": "Kampuchea (Cambodia )",
    "py": "J",
    "cn": "柬埔寨"
}, {
    "en": "Kazakstan",
    "py": "H",
    "cn": "哈萨克斯坦"
}, {
    "en": "Kenya",
    "py": "K",
    "cn": "肯尼亚"
}, {
    "en": "Korea",
    "py": "H",
    "cn": "韩国"
}, {
    "en": "Kuwait",
    "py": "K",
    "cn": "科威特"
}, {
    "en": "Kyrgyzstan",
    "py": "J",
    "cn": "吉尔吉斯坦"
}, {
    "en": "Laos",
    "py": "L",
    "cn": "老挝"
}, {
    "en": "Latvia",
    "py": "L",
    "cn": "拉脱维亚"
}, {
    "en": "Lebanon",
    "py": "L",
    "cn": "黎巴嫩"
}, {
    "en": "Lesotho",
    "py": "L",
    "cn": "莱索托"
}, {
    "en": "Liberia",
    "py": "L",
    "cn": "利比里亚"
}, {
    "en": "Libya",
    "py": "L",
    "cn": "利比亚"
}, {
    "en": "Liechtenstein",
    "py": "L",
    "cn": "列支敦士登"
}, {
    "en": "Lithuania",
    "py": "L",
    "cn": "立陶宛"
}, {
    "en": "Luxembourg",
    "py": "L",
    "cn": "卢森堡"
}, {
    "en": "Macao",
    "py": "A",
    "cn": "澳门"
}, {
    "en": "Madagascar",
    "py": "M",
    "cn": "马达加斯加"
}, {
    "en": "Malawi",
    "py": "M",
    "cn": "马拉维"
}, {
    "en": "Malaysia",
    "py": "M",
    "cn": "马来西亚"
}, {
    "en": "Maldives",
    "py": "M",
    "cn": "马尔代夫"
}, {
    "en": "Mali",
    "py": "M",
    "cn": "马里"
}, {
    "en": "Malta",
    "py": "M",
    "cn": "马耳他"
}, {
    "en": "Mariana Is",
    "py": "M",
    "cn": "马里亚那群岛"
}, {
    "en": "Martinique",
    "py": "M",
    "cn": "马提尼克"
}, {
    "en": "Mauritius",
    "py": "M",
    "cn": "毛里求斯"
}, {
    "en": "Mexico",
    "py": "M",
    "cn": "墨西哥"
}, {
    "en": "Moldova",
    "py": "M",
    "cn": "摩尔多瓦"
}, {
    "en": "Monaco",
    "py": "M",
    "cn": "摩纳哥"
}, {
    "en": "Mongolia",
    "py": "M",
    "cn": "蒙古"
}, {
    "en": "Montserrat Is",
    "py": "M",
    "cn": "蒙特塞拉特岛"
}, {
    "en": "Morocco",
    "py": "M",
    "cn": "摩洛哥"
}, {
    "en": "Mozambique",
    "py": "M",
    "cn": "莫桑比克"
}, {
    "en": "Namibia",
    "py": "N",
    "cn": "纳米比亚"
}, {
    "en": "Nauru",
    "py": "Z",
    "cn": "瑙鲁"
}, {
    "en": "Nepal",
    "py": "N",
    "cn": "尼泊尔"
}, {
    "en": "Netheriands Antilles",
    "py": "H",
    "cn": "荷属安的列斯"
}, {
    "en": "Netherlands",
    "py": "H",
    "cn": "荷兰"
}, {
    "en": "New Zealand",
    "py": "X",
    "cn": "新西兰"
}, {
    "en": "Nicaragua",
    "py": "N",
    "cn": "尼加拉瓜"
}, {
    "en": "Niger",
    "py": "N",
    "cn": "尼日尔"
}, {
    "en": "Nigeria",
    "py": "N",
    "cn": "尼日利亚"
}, {
    "en": "North Korea",
    "py": "C",
    "cn": "朝鲜"
}, {
    "en": "Norway",
    "py": "N",
    "cn": "挪威"
}, {
    "en": "Oman",
    "py": "A",
    "cn": "阿曼"
}, {
    "en": "Pakistan",
    "py": "B",
    "cn": "巴基斯坦"
}, {
    "en": "Panama",
    "py": "B",
    "cn": "巴拿马"
}, {
    "en": "Papua New Cuinea",
    "py": "B",
    "cn": "巴布亚新几内亚"
}, {
    "en": "Paraguay",
    "py": "B",
    "cn": "巴拉圭"
}, {
    "en": "Peru",
    "py": "M",
    "cn": "秘鲁"
}, {
    "en": "Philippines",
    "py": "F",
    "cn": "菲律宾"
}, {
    "en": "Poland",
    "py": "B",
    "cn": "波兰"
}, {
    "en": "Portugal",
    "py": "P",
    "cn": "葡萄牙"
}, {
    "en": "Puerto Rico",
    "py": "B",
    "cn": "波多黎各"
}, {
    "en": "Qatar",
    "py": "K",
    "cn": "卡塔尔"
}, {
    "en": "Reunion",
    "py": "L",
    "cn": "留尼旺"
}, {
    "en": "Romania",
    "py": "L",
    "cn": "罗马尼亚"
}, {
    "en": "Russia",
    "py": "E",
    "cn": "俄罗斯"
}, {
    "en": "Saint Lueia",
    "py": "S",
    "cn": "圣卢西亚"
}, {
    "en": "Saint Vincent",
    "py": "S",
    "cn": "圣文森特岛"
}, {
    "en": "Samoa Eastern",
    "py": "D",
    "cn": "东萨摩亚(美)"
}, {
    "en": "Samoa Western",
    "py": "X",
    "cn": "西萨摩亚"
}, {
    "en": "San Marino",
    "py": "S",
    "cn": "圣马力诺"
}, {
    "en": "Sao Tome and Principe",
    "py": "S",
    "cn": "圣多美和普林西比"
}, {
    "en": "Saudi Arabia",
    "py": "S",
    "cn": "沙特阿拉伯"
}, {
    "en": "Senegal",
    "py": "S",
    "cn": "塞内加尔"
}, {
    "en": "Seychelles",
    "py": "S",
    "cn": "塞舌尔"
}, {
    "en": "Sierra Leone",
    "py": "S",
    "cn": "塞拉利昂"
}, {
    "en": "Singapore",
    "py": "X",
    "cn": "新加坡"
}, {
    "en": "Slovakia",
    "py": "S",
    "cn": "斯洛伐克"
}, {
    "en": "Slovenia",
    "py": "S",
    "cn": "斯洛文尼亚"
}, {
    "en": "Solomon Is",
    "py": "S",
    "cn": "所罗门群岛"
}, {
    "en": "Somali",
    "py": "S",
    "cn": "索马里"
}, {
    "en": "South Africa",
    "py": "N",
    "cn": "南非"
}, {
    "en": "Spain",
    "py": "X",
    "cn": "西班牙"
}, {
    "en": "SriLanka",
    "py": "S",
    "cn": "斯里兰卡"
}, {
    "en": "St.Lucia",
    "py": "S",
    "cn": "圣卢西亚"
}, {
    "en": "St.Vincent",
    "py": "S",
    "cn": "圣文森特"
}, {
    "en": "Sudan",
    "py": "S",
    "cn": "苏丹"
}, {
    "en": "Suriname",
    "py": "S",
    "cn": "苏里南"
}, {
    "en": "Swaziland",
    "py": "S",
    "cn": "斯威士兰"
}, {
    "en": "Sweden",
    "py": "R",
    "cn": "瑞典"
}, {
    "en": "Switzerland",
    "py": "R",
    "cn": "瑞士"
}, {
    "en": "Syria",
    "py": "X",
    "cn": "叙利亚"
}, {
    "en": "Taiwan",
    "py": "T",
    "cn": "台湾省"
}, {
    "en": "Tajikstan",
    "py": "T",
    "cn": "塔吉克斯坦"
}, {
    "en": "Tanzania",
    "py": "T",
    "cn": "坦桑尼亚"
}, {
    "en": "Thailand",
    "py": "T",
    "cn": "泰国"
}, {
    "en": "Togo",
    "py": "D",
    "cn": "多哥"
}, {
    "en": "Tonga",
    "py": "T",
    "cn": "汤加"
}, {
    "en": "Trinidad and Tobago",
    "py": "T",
    "cn": "特立尼达和多巴哥"
}, {
    "en": "Tunisia",
    "py": "T",
    "cn": "突尼斯"
}, {
    "en": "Turkey",
    "py": "T",
    "cn": "土耳其"
}, {
    "en": "Turkmenistan",
    "py": "T",
    "cn": "土库曼斯坦"
}, {
    "en": "Uganda",
    "py": "W",
    "cn": "乌干达"
}, {
    "en": "Ukraine",
    "py": "W",
    "cn": "乌克兰"
}, {
    "en": "United Arab Emirates",
    "py": "A",
    "cn": "阿拉伯联合酋长国"
}, {
    "en": "United Kiongdom",
    "py": "Y",
    "cn": "英国"
}, {
    "en": "United States of America",
    "py": "M",
    "cn": "美国"
}, {
    "en": "Uruguay",
    "py": "W",
    "cn": "乌拉圭"
}, {
    "en": "Uzbekistan",
    "py": "W",
    "cn": "乌兹别克斯坦"
}, {
    "en": "Venezuela",
    "py": "W",
    "cn": "委内瑞拉"
}, {
    "en": "Vietnam",
    "py": "Y",
    "cn": "越南"
}, {
    "en": "Yemen",
    "py": "Y",
    "cn": "也门"
}, {
    "en": "Yugoslavia",
    "py": "N",
    "cn": "南斯拉夫"
}, {
    "en": "Zimbabwe",
    "py": "J",
    "cn": "津巴布韦"
}, {
    "en": "Zaire",
    "py": "Z",
    "cn": "扎伊尔"
}, {
    "en": "Zambia",
    "py": "Z",
    "cn": "赞比亚"
}]
export default country